export default {
  error: undefined,
  client: undefined,
  profiles: undefined,
  contacts: undefined,
  totalClientContactCount: 0,
  activeClientTab: 0,
  activePolicyTab: 0,
  activeLineOfBusinessTab: 0,
  activeVehicleTab: 0,
  autoVehicleTabGtagConfig: { action: 'Tab Navigation', category: 'Policy', label: 'Auto Vehicle Coverages Tab' },
  selectedProfileId: null,
  selectedLineOfBusinessCode: null,
  policyTitle: null,
  lobName: null
};
